import moment from 'moment';

import { toApiDateString } from '../helpers/dateFormatting';
import ISession from '../interfaces/ISession';
import ISite from '../interfaces/ISite';
import errorHelpers from '../helpers/errors';

class Sessions {
    static GetSessionTimes = (
        site: ISite,
        date: moment.Moment,
        players: number | undefined,
        accessCode: string | undefined,
        experienceId: number | undefined,
        packageTypeId: number | undefined,
        priceCode: string | undefined,
        signal?: AbortSignal
    ): Promise<Array<ISession>> => {
        const selectedDate: string = toApiDateString(date);
        const route = `sessions/${site.siteId}/${selectedDate}/${accessCode ?? ''}?experienceId=${
            experienceId ? experienceId : ''
        }&players=${players ? players : ''}&packageTypeId=${packageTypeId ? packageTypeId : ''}&priceCode=${
            priceCode ? priceCode : ''
        }`;

        return fetch(route, { signal })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<Array<ISession>>);
    };

    static GetSessionsById = (
        site: ISite,
        sessionId: number,
    ): Promise<ISession> => {
        const route = `sessions/GetSessionById/${site.siteId}/${sessionId}`

        return fetch(route)
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<ISession>)
    };
}

export default Sessions;
